import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ProductLeadTimeModule } from "@hermes/fragments/product-lead-time";
import { ProductShippingInformationModule } from "@hermes/fragments/product-shipping-information";
import { ShippingDelayMessageModule } from "@hermes/fragments/shipping-delay-message";

import { ProductDeliveryDetailsComponent } from "./components/product-delivery-details/product-delivery-details.component";

@NgModule({
    imports: [
        CommonModule,
        ShippingDelayMessageModule,
        ProductShippingInformationModule,
        ProductLeadTimeModule,
    ],
    declarations: [ProductDeliveryDetailsComponent],
    exports: [ProductDeliveryDetailsComponent],
})
export class ProductDeliveryDetailsModule {}
